module.exports = __webpack_public_path__ + "static/media/individual-icon.56fcf530.svg";